/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
  props: ["value"]
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "terms d-flex align-items-center" }, [
    _c(
      "button",
      {
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.$emit("input", !_vm.value)
          },
        },
      },
      [
        _c("i", {
          class: {
            "icon-square-o text-secondary": !_vm.value,
            "icon-check-square text-primary": _vm.value,
          },
        }),
      ]
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("\n    Li e concordo com os\n    "),
      _c(
        "a",
        {
          attrs: {
            href: "https://pay.velora.com.br/termos-de-uso/",
            target: "_blank",
          },
        },
        [_vm._v("termos de uso")]
      ),
      _vm._v("\n    e\n    "),
      _c(
        "a",
        {
          attrs: {
            href: "https://pay.velora.com.br/politica-de-privacidade/",
            target: "_blank",
          },
        },
        [_vm._v("políticas de privacidade")]
      ),
      _vm._v(".\n  "),
    ])
  },
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5166b64a_0", { source: ".terms {\n  font-size: 14px;\n}\n@media screen and (max-width: 991px) {\n.terms {\n    justify-content: center;\n    margin-bottom: 24px;\n    margin-top: -32px;\n}\n}\n.terms button {\n  padding: 4px;\n  border: none;\n  background: none;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  margin-right: 4px;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n}\n.terms a {\n  font-weight: bold;\n}\n\n/*# sourceMappingURL=terms.vue.map */", map: {"version":3,"sources":["frontend/components/terms.vue","terms.vue"],"names":[],"mappings":"AAwBA;EACA,eAAA;ACvBA;ADyBA;AAHA;IAIA,uBAAA;IACA,mBAAA;IACA,iBAAA;ACtBE;AACF;ADwBA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;ACtBA;ADyBA;EACA,iBAAA;ACvBA;;AAEA,oCAAoC","file":"terms.vue","sourcesContent":["<template>\n  <div class=\"terms d-flex align-items-center\">\n    <button @click=\"$emit('input', !value)\" type=\"button\">\n      <i :class=\"{\n        'icon-square-o text-secondary': !value,\n        'icon-check-square text-primary': value\n      }\"></i>\n    </button>\n    <span>\n      Li e concordo com os\n      <a href=\"https://pay.velora.com.br/termos-de-uso/\" target=\"_blank\">termos de uso</a>\n      e\n      <a href=\"https://pay.velora.com.br/politica-de-privacidade/\" target=\"_blank\">políticas de privacidade</a>.\n    </span>\n  </div>\n</template>\n\n<script>\nexport default {\n  props: [\"value\"]\n}\n</script>\n\n<style lang=\"scss\">\n.terms {\n  font-size: 14px;\n\n  @media screen and (max-width: 991px) {\n    justify-content: center;\n    margin-bottom: 24px;\n    margin-top: -32px;\n  }\n\n  button {\n    padding: 4px;\n    border: none;\n    background: none;\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    margin-right: 4px;\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n  }\n\n  a {\n    font-weight: bold;\n  }\n}\n</style>",".terms {\n  font-size: 14px;\n}\n@media screen and (max-width: 991px) {\n  .terms {\n    justify-content: center;\n    margin-bottom: 24px;\n    margin-top: -32px;\n  }\n}\n.terms button {\n  padding: 4px;\n  border: none;\n  background: none;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  margin-right: 4px;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n}\n.terms a {\n  font-weight: bold;\n}\n\n/*# sourceMappingURL=terms.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/terms.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__